module.exports = __webpack_public_path__ + "img/应用管理.4641aa44.png";